import { HospitalOperationTimeTypeEnum } from '@api/GoodocAPI';

export const operationTimes = [
  {
    id: '5915',
    from: '09:00:00',
    to: '18:00:00',
    operationOff: false,
    operationType: HospitalOperationTimeTypeEnum.Friday
  },
  {
    id: '5920',
    from: '00:00:00',
    to: '00:00:00',
    operationOff: true,
    operationType: HospitalOperationTimeTypeEnum.Holiday
  },
  {
    id: '5911',
    from: '09:00:00',
    to: '18:00:00',
    operationOff: false,
    operationType: HospitalOperationTimeTypeEnum.Monday
  },
  {
    id: '5916',
    from: '09:00:00',
    to: '18:00:00',
    operationOff: false,
    operationType: HospitalOperationTimeTypeEnum.Saturday
  },
  {
    id: '5917',
    from: '00:00:00',
    to: '00:00:00',
    operationOff: true,
    operationType: HospitalOperationTimeTypeEnum.Sunday
  },
  {
    id: '5914',
    from: '09:00:00',
    to: '18:00:00',
    operationOff: false,
    operationType: HospitalOperationTimeTypeEnum.Thursday
  },
  {
    id: '5912',
    from: '09:00:00',
    to: '18:00:00',
    operationOff: false,
    operationType: HospitalOperationTimeTypeEnum.Tuesday
  },
  {
    id: '5913',
    from: '09:00:00',
    to: '18:00:00',
    operationOff: false,
    operationType: HospitalOperationTimeTypeEnum.Wednesday
  },
  {
    id: '5918',
    from: '00:00:00',
    to: '00:00:00',
    operationOff: true,
    operationType: HospitalOperationTimeTypeEnum.WeekdayLunch
  },
  {
    id: '5919',
    from: '00:00:00',
    to: '00:00:00',
    operationOff: true,
    operationType: HospitalOperationTimeTypeEnum.WeekendLunch
  }
];
